// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Styles */
.root_sidebar {

  background-color: var(--sidebar-bg-color);
  color: var(--sidebar-color);
  transition: transform 0.3s ease, visibility 0.3s ease;
  flex-shrink: 0; /* Prevent shrinking */
  visibility: visible; /* Ensure it's visible by default */
}

.root_sidebar.closed {
  transform: translateX(0); /* Slide out of view */
  visibility: hidden;
   /* Completely hide the sidebar */
}


.root_sidebar.open {
  transform: translateX(0); /* Fully visible */
  visibility: visible;
}

/* Layout Styles */
.layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.main-content {
  flex: 1 1; /* Take full available space */
  display: flex;
  flex-direction: column;
  background-color:rgb(248, 248, 248);

  transition: margin-right 0.3s ease;
 padding: 0px 10px;
 overflow-y: scroll;
 padding-left: 20px;
}

/* Sidebar */
.root_sidebar {
  transition: width 0.3s ease;
}

.root_sidebar.open {
  width: 250px; /* Full width for open sidebar */
}

.root_sidebar.closed {
  width: 50px; /* Fixed width for closed sidebar */
}

/* For RTL and LTR directions */
.root_sidebar.ltr {
  left: 0;
  right: auto;
}

.root_sidebar.rtl {
  right: 0;
  left: auto;
}

/* Main Content */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  transition: margin 0.3s ease;
  padding-left: 20px;
}


.sidebar-open {
  background-color: #767171 !important;
}



.sidebar-closed.ltr .main-content {
  margin-left: 50px; /* Adjust for closed sidebar width */
}

.sidebar-open.rtl .main-content {
  margin-right: 250px; /* Adjust for open sidebar width */
  
}

.sidebar-closed.rtl .main-content {
  margin-right: 50px; /* Adjust for closed sidebar width */
}



/* Add this rule to remove outline on all elements */
* {
    outline: none !important;
}







`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;;EAEE,yCAAyC;EACzC,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc,EAAE,sBAAsB;EACtC,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,wBAAwB,EAAE,sBAAsB;EAChD,kBAAkB;GACjB,gCAAgC;AACnC;;;AAGA;EACE,wBAAwB,EAAE,kBAAkB;EAC5C,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO,EAAE,8BAA8B;EACvC,aAAa;EACb,sBAAsB;EACtB,mCAAmC;;EAEnC,kCAAkC;CACnC,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA,YAAY;AACZ;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,WAAW,EAAE,mCAAmC;AAClD;;AAEA,+BAA+B;AAC/B;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;;AAGA;EACE,oCAAoC;AACtC;;;;AAIA;EACE,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA;EACE,mBAAmB,EAAE,kCAAkC;;AAEzD;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;AAC1D;;;;AAIA,oDAAoD;AACpD;IACI,wBAAwB;AAC5B","sourcesContent":["/* Sidebar Styles */\n.root_sidebar {\n\n  background-color: var(--sidebar-bg-color);\n  color: var(--sidebar-color);\n  transition: transform 0.3s ease, visibility 0.3s ease;\n  flex-shrink: 0; /* Prevent shrinking */\n  visibility: visible; /* Ensure it's visible by default */\n}\n\n.root_sidebar.closed {\n  transform: translateX(0); /* Slide out of view */\n  visibility: hidden;\n   /* Completely hide the sidebar */\n}\n\n\n.root_sidebar.open {\n  transform: translateX(0); /* Fully visible */\n  visibility: visible;\n}\n\n/* Layout Styles */\n.layout {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.main-content {\n  flex: 1; /* Take full available space */\n  display: flex;\n  flex-direction: column;\n  background-color:rgb(248, 248, 248);\n\n  transition: margin-right 0.3s ease;\n padding: 0px 10px;\n overflow-y: scroll;\n padding-left: 20px;\n}\n\n/* Sidebar */\n.root_sidebar {\n  transition: width 0.3s ease;\n}\n\n.root_sidebar.open {\n  width: 250px; /* Full width for open sidebar */\n}\n\n.root_sidebar.closed {\n  width: 50px; /* Fixed width for closed sidebar */\n}\n\n/* For RTL and LTR directions */\n.root_sidebar.ltr {\n  left: 0;\n  right: auto;\n}\n\n.root_sidebar.rtl {\n  right: 0;\n  left: auto;\n}\n\n/* Main Content */\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  transition: margin 0.3s ease;\n  padding-left: 20px;\n}\n\n\n.sidebar-open {\n  background-color: #767171 !important;\n}\n\n\n\n.sidebar-closed.ltr .main-content {\n  margin-left: 50px; /* Adjust for closed sidebar width */\n}\n\n.sidebar-open.rtl .main-content {\n  margin-right: 250px; /* Adjust for open sidebar width */\n  \n}\n\n.sidebar-closed.rtl .main-content {\n  margin-right: 50px; /* Adjust for closed sidebar width */\n}\n\n\n\n/* Add this rule to remove outline on all elements */\n* {\n    outline: none !important;\n}\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
